import React, { useEffect, useState, useRef, useContext } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import UseStyles from "./UseStyles";
import Cleave from "cleave.js/react";
import Moment from "moment";

const Applicant = ({
	ApplicantData,
	currentSalesRep
}) => {
	const classes = UseStyles();

	return (
		<TableContainer component={Paper}>
			{
				/*!isApplicaitonInfoView ? (
				<Table className={classes.table} aria-label="simple table">
					<TableBody>
						<TableRow>
							<TableCell
								className={classes.cell_header_bold}
								align="left"
								fontWeight="fontWeightBold">
								Previous Owner
							</TableCell>
							<TableCell align="left">
								{ownerInfo ? ownerInfo?.previous_owner_name : "NA"}
							</TableCell>
							<TableCell
								className={classes.cell_header_bold}
								align="left"
								fontWeight="fontWeightBold">
								Broker Name
							</TableCell>
							<TableCell align="left">{ApplicantData.Broker_Name}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Application Id
							</TableCell>
							<TableCell align="left">{ApplicantData.id}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								Contract Number
							</TableCell>
							<TableCell align="left">{ApplicantData.Contract_Number}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Phone
							</TableCell>
							<TableCell align="left">{ApplicantData.Phone}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								SSN/FEIN (Applicant)
							</TableCell>
							<TableCell align="left">{ApplicantData.FEIN}</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			) : (*/
				<Table className={classes.table} aria-label="simple table">
					<TableBody>
						<TableRow>
							<TableCell
								className={classes.cell_header_bold}
								align="left"
								fontWeight="fontWeightBold">
								Broker Name
							</TableCell>
							<TableCell align="left">{ApplicantData.Broker_Name}</TableCell>
							{currentSalesRep &&
								<><TableCell className={classes.cell_header_bold} align="left">
									Sales Rep
								</TableCell>
									<TableCell align="left">{currentSalesRep}</TableCell>
								</>
							}
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Contract Number
							</TableCell>
							<TableCell align="left">{ApplicantData.Contract_Number}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								Account Manager
							</TableCell>
							<TableCell align="left">{ApplicantData.Account_Manager}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Referral Party Id
							</TableCell>
							<TableCell align="left">{ApplicantData.Referral_Party_Id}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								Invoice Amount
							</TableCell>
							<TableCell align="left">
								<Cleave
									disabled={true}
									style={{ border: 0, color: "black", fontSize: "0.75rem" }}
									value={
										ApplicantData.invoice_amount ? ApplicantData.invoice_amount : "0.0"
									}
									options={{
										prefix: "$",
										numeral: true,
										numeralThousandsGroupStyle: "thousand",
									}}
								/>
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								SSN/FEIN
							</TableCell>
							<TableCell align="left">{ApplicantData.FEIN}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								DBA
							</TableCell>
							<TableCell align="left">{ApplicantData.DBA}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Business Entity Type
							</TableCell>
							<TableCell align="left">{ApplicantData.Business_Entity_Type}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								Street Address
							</TableCell>
							<TableCell align="left">{ApplicantData.Street_Address}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Name
							</TableCell>
							<TableCell align="left">{ApplicantData.Name}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								Street Address Line 2
							</TableCell>
							<TableCell align="left">
								{ApplicantData.address2Type} {ApplicantData.Street_Address_Line_2}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Business Start Date
							</TableCell>
							<TableCell align="left">
								{Moment(ApplicantData.Business_Start_Date).format("MM/DD/YYYY")}
							</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								City/State/Zipcode
							</TableCell>
							<TableCell align="left">
								{ApplicantData.City},{ApplicantData.State},{ApplicantData.ZipCode}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Industry Experience
							</TableCell>
							<TableCell align="left">
								{Moment(ApplicantData.Industry_Experience).format("MM/DD/YYYY")}
							</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								Fax
							</TableCell>
							<TableCell align="left">{ApplicantData.FAX}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Phone
							</TableCell>
							<TableCell align="left">{ApplicantData.Phone}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								Email
							</TableCell>
							<TableCell align="left">{ApplicantData.Email}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Mobile
							</TableCell>
							<TableCell align="left">{ApplicantData.Mobile}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								CDL Expiration Date
							</TableCell>
							<TableCell align="left">
								{ApplicantData.CDL_Expiration_Date &&
									Moment(ApplicantData.CDL_Expiration_Date).format("MM/DD/YYYY")}
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								CDL Number
							</TableCell>
							<TableCell align="left">{ApplicantData.CDL_Number}</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								Is Discounted
							</TableCell>
							<TableCell align="left">{ApplicantData?.Is_Discounted}</TableCell>
						</TableRow>
						<TableRow>
							<TableCell className={classes.cell_header_bold} align="left">
								Approval expiration date
							</TableCell>
							<TableCell align="left">
								{ApplicantData?.credit_app_expiration_date
									? Moment(ApplicantData?.credit_app_expiration_date).format(
										"MM/DD/YYYY"
									)
									: Moment(ApplicantData?.credit_app_approval_date)
										.add(45, "days")
										.format("MM/DD/YYYY")}
							</TableCell>
							<TableCell className={classes.cell_header_bold} align="left">
								MC Number
							</TableCell>
							<TableCell align="left">{ApplicantData.sales_tax_exemption_number}</TableCell>
						</TableRow>
					</TableBody>
				</Table>
				//)
			}
			{/* <Button
				onClick={() => setIsExpanded(!isExpanded)}
				color="secondary"
				autoFocus>
				{!isExpanded ? "Show More " : "Show Less"}
			</Button> */}
		</TableContainer>
	);
};
export default Applicant;
